import { BracketHeading } from "../shared/components/BracketHeading";
import { FlowBracket } from "../shared/components/FlowBracket";
import { BracketProps } from "../shared/types/interfaces";
// import frame from "./frame.png";

const matchIndexPositions: {
  [key: number]: {
    node: {
      x: number;
      y: number;
    };
  };
} = {
  // lower bracket round 1
  0: {
    node: { x: 0, y: 305 },
  },
  // lower bracket round 2
  1: {
    node: { x: 0, y: 411 },
  },
  // lower bracket quarter final 1
  2: {
    node: { x: 234, y: 305 },
  },
  // lower bracket quarter final 2
  3: {
    node: { x: 234, y: 411 },
  },
  // upper bracket semi final 1
  4: {
    node: { x: 0, y: 42 },
  },
  // upper bracket semi final 2
  5: {
    node: { x: 0, y: 149 },
  },
  // lower bracket semi final
  6: {
    node: { x: 469, y: 358 },
  },
  // upper bracket final
  7: {
    node: { x: 703, y: 96 },
  },
  // lower bracket final
  8: {
    node: { x: 703, y: 358 },
  },
  // grand final
  9: {
    node: { x: 927, y: 206 },
  },
};

export const DoubleElim8Skewed = ({ gameId, bracket, pickedResults, onTeamClick }: BracketProps) => {
  if (!bracket.matches) return null;

  return (
    <div className="relative w-full">
      {/* Bracket */}
      <div className="custom-scrollbar relative overflow-x-auto overflow-y-hidden">
        {/* For dev only */}
        {/* <img
          className="absolute"
          src={frame}
          style={{
            top: "0",
            width: "1075px",
            minWidth: "1075px",
          }}
        /> */}

        <div
          style={{
            width: "1075px",
            minWidth: "1075px",
            height: "600px",
            minHeight: "600px",
          }}
        >
          <BracketHeading>Upper Bracket</BracketHeading>
          <BracketHeading
            style={{
              top: "264px",
            }}
          >
            Lower Bracket
          </BracketHeading>
          <FlowBracket
            gameId={gameId}
            circuitName={bracket.circuitName}
            tournamentName={bracket.parentTournamentName}
            matchIndexPositions={matchIndexPositions}
            matches={bracket.matches}
            pickedResults={pickedResults}
            onTeamClick={onTeamClick}
          />
        </div>
      </div>
    </div>
  );
};
